import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import Text from "@components/Text";
import { ITheme, themeDefault } from "src/theme-revamp";
import ReviewMessageBox from "./components/ReviewMessageBox";
import Accordion from "./components/Accordion";
import Listing from "../../Components/Listing";
import Button from "../../Components/Button";
import { useHistory } from "react-router-dom";
import { isEmpty, toArray } from "lodash";
import Modal from "@components/_Revamp/Modal";
import EditModal, { IEditModalData } from "./components/EditModal";
import ErrorModal, { IErrorModalData } from "./components/ErrorModal";
import { ROUTE_PATH } from "@static/route-paths";
import { Checkbox } from "../../Components/Checkbox";
import {
  FinancialAdviser,
  IHealthQuestion,
} from "@redux/slices/SHIELD_STARTER/step4Slice";
import { setLoadingState } from "@redux/slices/loadingSlice";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import { getPaymentUrl, savePlanData } from "@api/index";
import {
  PaymentStatus,
  updateReferenceNo,
} from "@redux/slices/SHIELD_STARTER/step5Slice";
import { CONTAINER_SIZE, SCREEN_SIZE } from "@static/screen-size";
import { Helpers, formatDate } from "@utils/helpers";
import useReduxReset from "@pages/ShieldStarter/Helpers/useReduxReset";
import {
  SHIELD_STARTER_HELTH_PLUS,
  SHIELD_STARTER,
} from "@static/staticConstents";
import MainContainer from "@pages/ShieldStarter/Components/Container";
import { trackOnLoad } from "@pages/ShieldStarter/Helpers/dataAnalyticsHelpers";
import {
  addNotification,
  clearNotifications,
} from "@redux/slices/SHIELD_STARTER/step1Slice";
import {
  NO_RIDER_NOTIFICATION,
  PAYMENT_ERROR_NOTIFICATION,
  ZERO_CASH_PAYMENT_NOTIFICATION,
} from "@static/NotificationTypes";
import {
  consentForMinorProps,
  ConsentTypes,
  SignatureProps,
} from "@redux/slices/SHIELD_STARTER/step3Slice";
import { CONSENT_ACCEPT_DECLARATION, CONSENT_LABEL } from "@static/content";
import { AccordionProps } from "@pages/ShieldStarter/Components/Accordion";
import { UrlAnalyticModel, UrlAnalyticTrackingModel } from "@models/MLTC_R3/UrlAnalytic.model";

enum ToastActions {
  ZERO_PAYAMENT,
  PAYMENT_UNSUCCESS,
}

enum REVIEW_PAGE {
  PLAN_SECTION,
  INFO_SECTION,
  CHILD_SECTION,
  CONSENT_SECTION,
  MAILING_SECTION,
  HEALTH_SECTION,
  AGENT_SECTION,
}

export interface EditBtnProps {
  onClick?: (e: any) => void;
}

const Review = () => {
  const urlParams: URLSearchParams = Helpers.getURLSearchParams();
  const history = useHistory();
  const resetStore = useReduxReset();
  const basicDetails = useAvivaSelector(
    (state) => state.shieldStarterStep2.policyName
  );
  const campaignDetail = useAvivaSelector(
    (state) => state.loading.campaignDetail
  );
  const myInfoForm: any = useAvivaSelector((state) => state.shieldStarterStep3);
  const {
    heightAndWeight,
    bmi,
    agentCode,
    agentName,
    agentResponce,
    autoAssignAgent,
    agentSourceOfBusiness,
    isCompleted: isHealthQnsCompleted,
  }: any = useAvivaSelector((state) => state.shieldStarterStep4);
  const healthQuestions = useAvivaSelector(
    (state) => state.shieldStarterStep4.uwQuestions
  );
  const planOverview = useAvivaSelector(
    (state) => state.shieldStarterStep2.planOverview
  );
  const rawQuotaion: any = useAvivaSelector(
    (state) => state.shieldStarterStep2.rawQuotaion
  );
  const { whomToBuy, existingPlan }: any = useAvivaSelector(
    (state) => state.shieldStarterStep1
  );
  const transactionId = useAvivaSelector(
    (state) => state.shieldStarterStep3.transactionId
  );
  const isPaymentDone = useAvivaSelector(
    (state) => state.shieldStarterStep5.isPaymentDone
  );
  const consentForMinor: consentForMinorProps = useAvivaSelector(
    (state) => state.shieldStarterStep3.consentForMinor
  );
  const signature: SignatureProps = useAvivaSelector(
    (state) => state.shieldStarterStep3.signature
  );
  const uploadedFiles: any = useAvivaSelector(
    (state) => state.shieldStarterStep3.fileProgress
  );

  const [editModalVisible, setEditModalVisible] = useState<boolean>(false);
  const [errorModalVisible, setErrorModalVisible] = useState<boolean>(false);
  const [editModalData, setEditModalData] = useState<IEditModalData | null>(
    null
  );
  const [errorModalData, setErrorModalData] = useState<IErrorModalData | null>(
    null
  );
  const [isExpanded, setIsExpanded] = useState(REVIEW_PAGE.PLAN_SECTION);
  const screenBreakPoint = useRef(-1);
  const [isPaymentAllowed, setIsPaymentAllowed] = useState(true);

  const planRef = useRef<any>(null);
  const infoRef = useRef<any>(null);
  const mailRef = useRef<any>(null);
  const childRef = useRef<any>(null);
  const healthRef = useRef<any>(null);
  const agentRef = useRef<any>(null);
  const consentRef = useRef<any>(null);
  const prevIsExpanded = useRef(-1);
  const analyticUrlParams = useAvivaSelector(state => state.urlAnalytic.param);
  const isSameAsResidentialAddress = useAvivaSelector((state) =>
    state.shieldStarterStep3.personalInfo.mailingAddress ? "N" : "Y"
  );

  const EditComponent = ({ onClick }: EditBtnProps) => {
    return <EditBtnParagraph onClick={onClick}>Edit</EditBtnParagraph>;
  };

  const displayModal = (e: any, path: string, pageTitle: string) => {
    e.stopPropagation();
    setEditModalVisible(true);
    let obj = {
      title: pageTitle,
      onBackClick: () => {
        setEditModalVisible(false);
      },
      onProceedClick: () => {
        if (path.includes("transaction_id")) {
          history.push(`${path}&review=1`);
        } else {
          history.push(`${path}?review=1`);
        }
        setEditModalVisible(true);
      },
    };
    setEditModalData(obj);
  };

  const displayErrorModal = (desc: string, isOnlyContact: boolean) => {
    setErrorModalVisible(true);
    let obj = {
      title: "We’ve encountered an issue",
      description: desc,
      backButtonText: "Contact us",
      proceedButtonText: "Get a new quote",
      contactOnly: isOnlyContact,
      onBackClick: () => {
        setErrorModalVisible(false);
        history.push(ROUTE_PATH.SHIELD_STARTER_CONTACT_US);
      },
      onProceedClick: () => {
        resetStore();
        setErrorModalVisible(false);
        history.push(ROUTE_PATH.SHIELD_STARTER_GET_QUOTE);
      },
    };
    setErrorModalData(obj);
  };

  const updateClosed = () => {
    switch (prevIsExpanded.current) {
      case REVIEW_PAGE.PLAN_SECTION: {
        planRef.current?.closeAccordion();
        break;
      }
      case REVIEW_PAGE.AGENT_SECTION: {
        agentRef.current?.closeAccordion();
        break;
      }
      case REVIEW_PAGE.CHILD_SECTION: {
        childRef.current?.closeAccordion();
        break;
      }
      case REVIEW_PAGE.CONSENT_SECTION: {
        consentRef.current?.closeAccordion();
        break;
      }
      case REVIEW_PAGE.HEALTH_SECTION: {
        healthRef.current?.closeAccordion();
        break;
      }
      case REVIEW_PAGE.INFO_SECTION: {
        infoRef.current?.closeAccordion();
        break;
      }
      case REVIEW_PAGE.MAILING_SECTION: {
        mailRef.current?.closeAccordion();
        break;
      }
    }
  };

  useEffect(() => {
    function scrollBy(ref: any, screenBreakPoint: { current: number }) {
      setTimeout(() => {
        if (ref.current) {
          const calculatedScroll =
            ref.current.accordionRef.getBoundingClientRect().top -
            screenBreakPoint.current;
          if (calculatedScroll <= 0) {
            window.scrollTo(0, 0);
            window.scrollBy(
              0,
              ref.current.accordionRef.getBoundingClientRect().top -
                screenBreakPoint.current
            );
            return;
          }
          window.scrollBy(0, calculatedScroll);
        }
      }, 350);
    }
    function scrollCalculator(message: any) {
      switch (message.onOpenOrCloseEventMessage.id) {
        case REVIEW_PAGE.PLAN_SECTION: {
          scrollBy(planRef, screenBreakPoint);
          break;
        }
        case REVIEW_PAGE.AGENT_SECTION: {
          scrollBy(agentRef, screenBreakPoint);
          break;
        }
        case REVIEW_PAGE.CHILD_SECTION: {
          scrollBy(childRef, screenBreakPoint);
          break;
        }
        case REVIEW_PAGE.CONSENT_SECTION: {
          scrollBy(consentRef, screenBreakPoint);
          break;
        }
        case REVIEW_PAGE.HEALTH_SECTION: {
          scrollBy(healthRef, screenBreakPoint);
          break;
        }
        case REVIEW_PAGE.INFO_SECTION: {
          scrollBy(infoRef, screenBreakPoint);
          break;
        }
        case REVIEW_PAGE.MAILING_SECTION: {
          scrollBy(mailRef, screenBreakPoint);
          break;
        }
      }
    }
    if (screenBreakPoint.current !== -1) {
      scrollCalculator({ onOpenOrCloseEventMessage: { id: isExpanded } });
    }
  }, [isExpanded]);

  useEffect(() => {
    function resize() {
      if (window.innerWidth <= SCREEN_SIZE.mobilesUp) {
        screenBreakPoint.current = 0;
      } else if (window.innerWidth <= 1249) {
        screenBreakPoint.current = 190;
      } else if (window.innerWidth > 1249) {
        screenBreakPoint.current = 90;
      }
    }
    if (screenBreakPoint.current === -1) {
      resize();
    }

    window.addEventListener("resize", resize);
    return () => {
      window.removeEventListener("resize", resize);
    };
  }, []);
  useEffect(() => {
    if (
      isEmpty(basicDetails) ||
      isEmpty(myInfoForm?.personalInfo) ||
      isPaymentDone ||
      !isHealthQnsCompleted
    ) {
      resetStore();
      history.push(ROUTE_PATH.SHIELD_STARTER_GET_QUOTE);
      return;
    }

    const paymentStatus = urlParams.get("status");
    if (paymentStatus === PaymentStatus.FAIL) {
      //Send analytics when the payment is failed or cancelled
      trackOnLoad("sss_review_form_payment_failure");
      setTimeout(() => {
        dispatch(addNotification(PAYMENT_ERROR_NOTIFICATION));
      }, 3000);
      return;
    }
    trackOnLoad("sss_review_form");
  }, []);

  useEffect(() => {
    if (planOverview?.PlanOverViewData?.totalCashPayble === "0.00") {
      dispatch(addNotification(ZERO_CASH_PAYMENT_NOTIFICATION));
      setIsPaymentAllowed(true);
    }

    if (basicDetails === SHIELD_STARTER)
      dispatch(addNotification(NO_RIDER_NOTIFICATION));

    return () => {
      dispatch(clearNotifications());
    };
  }, []);

  function getPlanValues(param: string) {
    const prefix = [
      "promoCodeDiscount",
      "basePlanPriceNoGst",
      "MediSaveDeduction",
    ].includes(param)
      ? "-"
      : "";

    const params = planOverview?.PlanOverViewData?.[param];

    return (params === 0 || params) && params !== "-"
      ? prefix + "S$" + params
      : "-";
  }

  const planSummarySources = [
    {
      heading: {
        text: "Plan",
        value: `${basicDetails}`,
      },
    },
    {
      heading: {
        text: "Policy Term",
        value: `Yearly Renewable`,
      },
    },
    {
      heading: {
        text: "Premium Term",
        value: `Yearly Renewable`,
      },
    },
    {
      heading: {
        text: "Annual Premium with GST",
        value: getPlanValues("subTotalAmount"),
      },
      isPlanSummary: 1,
      descriptions: [
        {
          text: `CPF MediSave deduction`,
          value: getPlanValues("MediSaveDeduction"),
        },
        {
          text: `Promo Code ${
            planOverview?.PlanOverViewData?.promoCode
              ? `(${planOverview?.PlanOverViewData?.promoCode})`
              : ""
          }`,
          value: getPlanValues("promoCodeDiscount"),
        },
        {
          text: `Cash Payment (after CPF MediSave Deduction)`,
          value: getPlanValues("totalCashPayble"),
        },
      ],
    },
  ];

  const personalInformationSources = [
    {
      heading: {
        text: "Full Name (as per NRIC/FIN)",
        value: `${myInfoForm.personalInfo?.fullName || "-"}`,
      },
    },
    {
      heading: {
        text: "First Name/Given Name",
        value: `${myInfoForm.personalInfo?.firstName || "-"}`,
      },
    },
    {
      heading: {
        text: "Last Name/Family Name",
        value: `${myInfoForm.personalInfo?.lastName || "-"}`,
      },
    },
    {
      heading: {
        text: "Salutation",
        value: `${myInfoForm.personalInfo?.salutation || "-"}`,
      },
    },
    {
      heading: {
        text: "NRIC/FIN",
        value: `${myInfoForm.personalInfo?.nric || "-"}`,
      },
    },
    {
      heading: {
        text: "Date of Birth",
        value: `${
          myInfoForm.personalInfo?.dateOfBirth
            ? formatDate(myInfoForm.personalInfo?.dateOfBirth)
            : "-"
        }`,
      },
    },
    {
      heading: {
        text: "Gender",
        value: `${myInfoForm.personalInfo?.gender || "-"}`,
      },
    },
    {
      heading: {
        text: "Mobile Number",
        value: `${
          myInfoForm.personalInfo?.mobileNum
            ? `+65 ${(myInfoForm.personalInfo?.mobileNum).substr(0, 4)}
             ${(myInfoForm.personalInfo?.mobileNum).substr(4, 8)}`
            : "-"
        }`,
      },
    },
    {
      heading: {
        text: "Email",
        value: `${myInfoForm.personalInfo?.emailId || "-"}`,
      },
    },
    {
      heading: {
        text: "Postal Code",
        value: `${myInfoForm.personalInfo?.address?.postal || "-"}`,
      },
    },
    {
      heading: {
        text: "Unit (If any)",
        value: `${myInfoForm.personalInfo?.address?.unitNo || "-"}`,
      },
    },
    {
      heading: {
        text: "Street Name",
        value: `${myInfoForm.personalInfo?.address?.street || "-"}`,
      },
    },
    {
      heading: {
        text: "Block",
        value: `${myInfoForm.personalInfo?.address?.block || "-"}`,
      },
    },
    {
      heading: {
        text: "Building Name (If any)",
        value: `${myInfoForm.personalInfo?.address?.building || "-"}`,
      },
    },
  ];

  const childDetailsSources = [
    {
      heading: {
        text: "Full Name (as per NRIC/FIN)",
        value: `${myInfoForm?.selectedChildInfo?.fullName || "-"}`,
      },
    },
    {
      heading: {
        text: "First Name/Given Name",
        value: `${myInfoForm.selectedChildInfo?.firstName || "-"}`,
      },
    },
    {
      heading: {
        text: "Last Name/Family Name",
        value: `${myInfoForm.selectedChildInfo?.lastName || "-"}`,
      },
    },
    {
      heading: {
        text: "Salutation",
        value: `${myInfoForm.selectedChildInfo?.salutation || "-"}`,
      },
    },
    {
      heading: {
        text: "NRIC/ FIN",
        value: `${myInfoForm.selectedChildInfo?.nric || "-"}`,
      },
    },
    {
      heading: {
        text: "Date of Birth",
        value: `${
          myInfoForm.selectedChildInfo?.dateOfBirth
            ? formatDate(myInfoForm.selectedChildInfo?.dateOfBirth)
            : "-"
        }`,
      },
    },
    {
      heading: {
        text: "Gender",
        value: `${myInfoForm.selectedChildInfo?.gender || "-"}`,
      },
    },
  ];

  function getMailingAddress(
    param: string,
    isMailingAddressOnly: boolean = false
  ) {
    if (!isMailingAddressOnly) {
      return myInfoForm.personalInfo?.address?.[param] || "";
    }

    return myInfoForm.personalInfo?.mailingAddress
      ? myInfoForm.personalInfo?.mailingAddress?.[param] || ""
      : myInfoForm.personalInfo?.address?.[param] || "";
  }

  const mailDetailsSources = [
    {
      heading: {
        text: "Postal Code",
        value: getMailingAddress("postal", true) || "-",
      },
    },
    {
      heading: {
        text: "Unit (If any)",
        value: getMailingAddress("unitNo", true) || "-",
      },
    },
    {
      heading: {
        text: "Street Name",
        value: getMailingAddress("street", true) || "-",
      },
    },
    {
      heading: {
        text: "Block",
        value: getMailingAddress("block", true) || "-",
      },
    },
    {
      heading: {
        text: "Building Name (If any)",
        value: getMailingAddress("building", true) || "-",
      },
    },
  ];

  function getHealthQuestions() {
    return healthQuestions.map((qns: IHealthQuestion) => {
      const descriptions =
        qns.numOfColumn === 1
          ? qns.questionPoints.map((e: any) => {
              return {
                text: e.QuestionPointDescription,
                value: ``,
              };
            })
          : [
              {
                text: `${qns.questionPoints
                  .map((e: any) => e.QuestionPointDescription)
                  .join(", ")}`,
                value: ``,
              },
            ];

      return {
        heading: {
          text: `${qns.questionData}`,
          value: `Nil`,
        },
        descriptions,
      };
    });
  }

  const healthSources = [
    {
      heading: {
        text: "Height",
        value: `${
          heightAndWeight?.height ? heightAndWeight?.height + "cm" : "-"
        }`,
      },
    },
    {
      heading: {
        text: "Weight",
        value: `${
          heightAndWeight?.weight ? heightAndWeight?.weight + "kg" : "-"
        }`,
      },
    },
  ];

  const consentForMinorSources = [
    {
      heading: {
        text: "Consent provided by",
        value: `${CONSENT_LABEL[consentForMinor?.type]}`,
      },
    },
    {
      heading: {
        text: `Full Name of ${CONSENT_LABEL[consentForMinor?.type]}`,
        value: `${consentForMinor?.fullName || "-"}`,
      },
    },
    {
      heading: {
        text: `Signature of ${CONSENT_LABEL[consentForMinor?.type]}`,
        value: signature?.attachmentId ? "Signed" : "-",
      },
    },
    {
      heading: {
        text: `${CONSENT_ACCEPT_DECLARATION[consentForMinor?.type]}`,
        value: `${consentForMinor?.consentAccepted ? `Declared` : `-`}`,
      },
    },
  ];

  const consentForMinorNeitherSources = [
    {
      heading: {
        text: "Consent provided by",
        value: `Neither parent nor legal guardian`,
      },
    },
    {
      heading: {
        text: `${CONSENT_ACCEPT_DECLARATION[consentForMinor?.type]}`,
        value: `${consentForMinor?.consentAccepted ? `Declared` : `-`}`,
      },
    },
  ];

  const agentDetailsSources = [
    {
      heading: {
        text: "Do you need a financial adviser representative to service this policy?",
        value: `${
          agentCode
            ? "I have a financial adviser representative in mind"
            : autoAssignAgent === FinancialAdviser.ARISTOTLE
            ? "Singlife to assign a financial adviser representative"
            : "No, I do not need a financial adviser representative"
        }`,
      },
    },
    {
      heading: {
        text: "Financial Adviser Representative Code",
        value: `${agentCode || "-"}`,
      },
    },
    {
      heading: {
        text: "Name",
        value: `${agentName || "-"}`,
      },
    },
  ];

  const dispatch = useAvivaDispatch();

  async function initatePayment(referenceNumber: string) {
    try {
      dispatch(setLoadingState(true));
      const payload = {
        amount: planOverview?.PlanOverViewData?.totalCashPayble,
        referenceNumber,
        contractCode:
          basicDetails === SHIELD_STARTER_HELTH_PLUS ? "MSP" : "MYS",
        productName:
          basicDetails === SHIELD_STARTER_HELTH_PLUS ? "NP5C" : "MSI5",
      };
      const { data } = await getPaymentUrl(payload);
      dispatch(setLoadingState(false));
      window.open(data, "_self");
    } catch (error) {
      dispatch(setLoadingState(false));
      history.push(ROUTE_PATH.SHIELD_STARTER_GENERIC_ERROR);
    }
  }

  const getPolicyDetails = () => {
    const policies = [];

    const attachmentList = toArray(uploadedFiles).map((file) => {
      if (file?.attachmentId) {
        return {
          attachmentId: file?.attachmentId,
        };
      }
    });

    if (signature?.attachmentId) {
      attachmentList.push({
        attachmentId: signature.attachmentId,
      });
    }

    const commonData = {
      trackingCodeJson: new UrlAnalyticTrackingModel(analyticUrlParams).trackingCodeJson, // TBD
      // quotationRespData: JSON.stringify(rawQuotaion),
      agentSourceCode: agentCode.replaceAll("  ", ""),
      agentSourceOfBusiness,
      agentDetailsRespData: !isEmpty(agentResponce)
        ? JSON.stringify(agentResponce)
        : "{}",
      agentOptionChosen: autoAssignAgent || FinancialAdviser.NO_AGENT,
      planStructure: "LEVEL", // TBD
      insuredType: whomToBuy,
      currentInsurer: existingPlan,
      premiumTerm: "Yearly renewable",
      promoCode: planOverview?.PlanOverViewData?.promoCode,
      campaignCode: campaignDetail?.campaignCode,
      formType: !!campaignDetail ? campaignDetail?.code : "", // TBD
      partnerCode: campaignDetail?.partner,
    };

    policies.push({
      contractCode: "MYS",
      productCode: "MSI5",
      planName: SHIELD_STARTER,
      totalAnnualPremium: rawQuotaion.coverages[0].attributes.annualPremium,
      afterPromoDiscount:
        rawQuotaion.coverages[0].attributes.discountedPremium
          .firstYrModalPremium || rawQuotaion.coverages[0].attributes.annualPremium,
      firstYearDiscount:
        rawQuotaion.coverages[0].attributes.discountedPremium.firstYrDiscAmnt,
      discountType:
        rawQuotaion.coverages[0].attributes.discountedPremium.firstYrDiscType,
      cpfMedisaveAmount:
        rawQuotaion.coverages[0].attributes.bbbCpfMediSaveDeduction,
      paymentMode: "CPF",
      attachmentDetailDTO: attachmentList,
      ...commonData,
    });

    if (basicDetails === SHIELD_STARTER_HELTH_PLUS) {
      policies.push({
        contractCode: "MSP",
        productCode: "NP5C",
        planName: SHIELD_STARTER_HELTH_PLUS,
        totalAnnualPremium: rawQuotaion.coverages[1].attributes.annualPremium,
        afterPromoDiscount:
          rawQuotaion.coverages[1].attributes.discountedPremium
            .firstYrModalPremium || rawQuotaion.coverages[1].attributes.annualPremium,
        firstYearDiscount:
          rawQuotaion.coverages[1].attributes.discountedPremium.firstYrDiscAmnt,
        discountType:
          rawQuotaion.coverages[1].attributes.discountedPremium.firstYrDiscType,
        cpfMedisaveAmount:
          rawQuotaion.coverages[1].attributes.bbbCpfMediSaveDeduction,
        paymentMode: "CC",
        ...commonData,
      });
    }

    return policies;
  };

  async function handleSavePlan() {
    try {
      dispatch(setLoadingState(true));
      const policyDetailDTO = getPolicyDetails();

      const payload = {
        personalDetailDTO: {
          customerDetailDTO: {
            customerId: myInfoForm?.personalInfo?.customerId,
            salutation: myInfoForm?.personalInfo?.salutation,
            fullName: myInfoForm?.personalInfo?.fullName,
            firstName: myInfoForm.personalInfo?.firstName,
            lastName: myInfoForm.personalInfo?.lastName,
            emailId: myInfoForm.personalInfo?.emailId,
            mobileNo: myInfoForm.personalInfo?.mobileNum,
            dob: myInfoForm?.personalInfo?.dateOfBirth,
            nric: myInfoForm?.personalInfo?.nric,
            nationality: myInfoForm?.personalInfo?.nationality,
            residentialStatus: myInfoForm?.personalInfo?.residentialStatus,
            gender: myInfoForm?.personalInfo?.gender,
            customerConsent: myInfoForm?.personalInfo?.stayInTouch,
            nationalityCode: myInfoForm?.personalInfo?.nationalityCode,
          },
          addressDetailDTO: {
            postCode: getMailingAddress("postal"),
            unitNumber: getMailingAddress("unitNo"),
            streetName: getMailingAddress("street"),
            block: getMailingAddress("block"),
            buildingName: getMailingAddress("building"),
          },
          mailingAddressDTO: {
            isSameAsResidentialAddress,
            postCode: getMailingAddress("postal", true),
            unitNumber: getMailingAddress("unitNo", true),
            streetName: getMailingAddress("street", true),
            block: getMailingAddress("block", true),
            buildingName: getMailingAddress("building", true),
            useMailAddressForAll: !getMailingAddress(
              "useMailAddressForAll",
              true
            )
              ? "N"
              : "Y",
          },
          selectedChildInfo: !isEmpty(myInfoForm?.selectedChildInfo)
            ? myInfoForm?.selectedChildInfo
            : null,
          otherDetailDTO: {
            height: +heightAndWeight?.height,
            weight: +heightAndWeight?.weight,
            bmi,
          },
          otherProposerDetail: consentForMinor.type
            ? {
                selectedProposerCategory: consentForMinor.type,
                declarationCheck: consentForMinor.consentAccepted,
                fullName: consentForMinor.fullName,
              }
            : null,
        },
        policyDetailDTO,
        insuredType: whomToBuy,
        isAuthorizedPay: isPaymentAllowed ? 1 : 0,
        transactionId,
      };

      const { data } = await savePlanData(payload);

      if (data.error && data.error.errorMessage) {
        const hideRestartJourneyBtn = data.error.errorCode !== "1005";
        displayErrorModal(data.error.errorMessage, hideRestartJourneyBtn);
        dispatch(setLoadingState(false));
        return;
      }

      dispatch(
        updateReferenceNo({
          paymentRef: data?.paymentRef,
          policyNo: data?.policyNo,
          riderPolicyNo: data?.riderPolicyNo,
        })
      );
      dispatch(setLoadingState(false));
      dispatch(clearNotifications());
      initatePayment(data?.paymentRef);
    } catch (error) {
      dispatch(setLoadingState(false));
      history.push(ROUTE_PATH.SHIELD_STARTER_GENERIC_ERROR);
    }
  }
  const scrollOptions: ScrollIntoViewOptions = {
    behavior: "smooth",
    block: "center",
    inline: "center",
  };

  return (
    <MainContainer
      step={5}
      backButtonPath={
        campaignDetail
          ? ROUTE_PATH.SHIELD_STARTER_DECLARATION
          : ROUTE_PATH.SHIELD_STARTER_ADVISER
      }
    >
    <Aligner>
      <FormContainer>
        <FormHeaderContainer>
          <FormHeaderTitleContainer>
            <Text
              align={"center"}
              theme={themeDefault}
              className={HeaderTitleCss}
            >
              Review your application
            </Text>
          </FormHeaderTitleContainer>
          <FormHeaderDescriptionContainer>
            <Text theme={themeDefault} className={HeaderDescriptionCss}>
              Almost there! Check that all information is correct before making
              payment
            </Text>
          </FormHeaderDescriptionContainer>
        </FormHeaderContainer>
      </FormContainer>

      <FormContentContainer>
        <AccordianContainer>
          <ReviewMessageBox>
            <Text theme={themeDefault} className={MessageBoxParagraphCss}>
              <b>Note:</b> Pursuant to Section 23(5) of the Insurance Act 1966,
              you are required to disclose in this application form fully and
              faithfully all facts which you know or ought to know. Otherwise
              the insurance effected may be void.
            </Text>
          </ReviewMessageBox>
        </AccordianContainer>
      </FormContentContainer>

      <FormContentContainer>
        <>
          <AccordianContainer
            onClick={(e) => {
              if (prevIsExpanded.current !== isExpanded) {
                prevIsExpanded.current = isExpanded;
                updateClosed();
              }
              setIsExpanded(REVIEW_PAGE.PLAN_SECTION);
            }}
          >
            <Accordion
              ref={planRef}
              isExpanded={isExpanded === REVIEW_PAGE.PLAN_SECTION}
              {...args}
              extraElement={
                <EditComponent
                  onClick={(e) => {
                    displayModal(
                      e,
                      ROUTE_PATH.SHIELD_STARTER_CHOOSE_PLAN,
                      "Plan Selection"
                    );
                  }}
                />
              }
              title="Plan Summary"
            >
              <Listing
                sources={planSummarySources}
                variant="alternate"
                underlineColor="#F5F5F5"
                margin=""
              />
            </Accordion>
          </AccordianContainer>

          <AccordianContainer
            onClick={() => {
              if (prevIsExpanded.current !== isExpanded) {
                prevIsExpanded.current = isExpanded;
                updateClosed();
              }
              setIsExpanded(REVIEW_PAGE.INFO_SECTION);
            }}
          >
            <Accordion
              ref={infoRef}
              isExpanded={isExpanded === REVIEW_PAGE.INFO_SECTION}
              {...args}
              extraElement={
                <EditComponent
                  onClick={(e) => {
                    displayModal(
                      e,
                      `${ROUTE_PATH.SHIELD_STARTER_MY_INFO}?transaction_id=${transactionId}`,
                      "My Information"
                    );
                  }}
                />
              }
              title="Personal Information"
            >
              <Listing
                sources={personalInformationSources}
                variant="alternate"
                underlineColor="#F5F5F5"
                margin=""
              />
            </Accordion>
          </AccordianContainer>

          {whomToBuy === "child" && (
            <AccordianContainer
              onClick={() => {
                if (prevIsExpanded.current !== isExpanded) {
                  prevIsExpanded.current = isExpanded;
                  updateClosed();
                }
                setIsExpanded(REVIEW_PAGE.CHILD_SECTION);
              }}
            >
              <Accordion
                isExpanded={isExpanded === REVIEW_PAGE.CHILD_SECTION}
                ref={childRef}
                {...args}
                extraElement={
                  <EditComponent
                    onClick={(e) => {
                      displayModal(
                        e,
                        `${ROUTE_PATH.SHIELD_STARTER_MY_INFO}?transaction_id=${transactionId}`,
                        "My Information"
                      );
                    }}
                  />
                }
                title="Child Information"
              >
                <Listing
                  sources={childDetailsSources}
                  variant="alternate"
                  underlineColor="#F5F5F5"
                  margin=""
                />
              </Accordion>
            </AccordianContainer>
          )}

          {consentForMinor.type && (
            <AccordianContainer
              onClick={() => {
                if (prevIsExpanded.current !== isExpanded) {
                  prevIsExpanded.current = isExpanded;
                  updateClosed();
                }
                setIsExpanded(REVIEW_PAGE.CONSENT_SECTION);
              }}
            >
              <Accordion
                ref={consentRef}
                isExpanded={isExpanded === REVIEW_PAGE.CONSENT_SECTION}
                {...args}
                extraElement={
                  <EditComponent
                    onClick={(e) => {
                      displayModal(
                        e,
                        `${ROUTE_PATH.SHIELD_STARTER_MY_INFO}?transaction_id=${transactionId}`,
                        "My Information"
                      );
                    }}
                  />
                }
                title="Consent for Minor"
              >
                <Listing
                  sources={consentForMinor?.type === ConsentTypes.NEITHER ? consentForMinorNeitherSources : consentForMinorSources}
                  variant="alternate"
                  underlineColor="#F5F5F5"
                  margin=""
                />
              </Accordion>
            </AccordianContainer>
          )}
          <AccordianContainer
            onClick={() => {
              if (prevIsExpanded.current !== isExpanded) {
                prevIsExpanded.current = isExpanded;
                updateClosed();
              }
              setIsExpanded(REVIEW_PAGE.MAILING_SECTION);
            }}
          >
            <Accordion
              ref={mailRef}
              isExpanded={isExpanded === REVIEW_PAGE.MAILING_SECTION}
              {...args}
              extraElement={
                <EditComponent
                  onClick={(e) => {
                    displayModal(
                      e,
                      ROUTE_PATH.SHIELD_STARTER_MAILING_ADDRESS,
                      "My Information"
                    );
                  }}
                />
              }
              title="Mailing Address"
            >
              <Listing
                sources={mailDetailsSources}
                variant="alternate"
                underlineColor="#F5F5F5"
                margin=""
              />
            </Accordion>
          </AccordianContainer>

          <AccordianContainer
            onClick={() => {
              if (prevIsExpanded.current !== isExpanded) {
                prevIsExpanded.current = isExpanded;
                updateClosed();
              }
              setIsExpanded(REVIEW_PAGE.HEALTH_SECTION);
            }}
          >
            <Accordion
              ref={healthRef}
              isExpanded={isExpanded === REVIEW_PAGE.HEALTH_SECTION}
              {...args}
              extraElement={
                <EditComponent
                  onClick={(e) => {
                    displayModal(
                      e,
                      ROUTE_PATH.SHIELD_STARTER_HEALTH_DECLARATION,
                      "Health Declaration"
                    );
                  }}
                />
              }
              title="Health Questions"
            >
              <Listing
                sources={
                  !isEmpty(healthQuestions)
                    ? [...healthSources, ...getHealthQuestions()]
                    : healthSources
                }
                variant="alternate"
                underlineColor="#F5F5F5"
                margin=""
              />
            </Accordion>
          </AccordianContainer>

          {!campaignDetail && (
            <AccordianContainer
              onClick={() => {
                if (prevIsExpanded.current !== isExpanded) {
                  prevIsExpanded.current = isExpanded;
                  updateClosed();
                }
                setIsExpanded(REVIEW_PAGE.AGENT_SECTION);
              }}
            >
              <Accordion
                ref={agentRef}
                isExpanded={isExpanded === REVIEW_PAGE.AGENT_SECTION}
                {...args}
                extraElement={
                  <EditComponent
                    onClick={(e) => {
                      displayModal(
                        e,
                        ROUTE_PATH.SHIELD_STARTER_ADVISER,
                        "Adviser Selection"
                      );
                    }}
                  />
                }
                title="Financial Adviser Representative"
              >
                <Listing
                  sources={agentDetailsSources}
                  variant="alternate"
                  underlineColor="#F5F5F5"
                  margin=""
                />
              </Accordion>
            </AccordianContainer>
          )}
        </>
      </FormContentContainer>

      {planOverview?.PlanOverViewData?.totalCashPayble !== "0.00" && (
        <AllowDataUsageContainer>
          <Checkbox
            checked={isPaymentAllowed}
            onChange={(e: any) => setIsPaymentAllowed(e.target.value)}
            isWhiteCheckbox
          >
            <DataUsageDescription theme={themeDefault}>
              I authorise Singapore Life Ltd. to charge the initial and
              subsequent premium(s) to my credit card account for this insurance
              policy.
            </DataUsageDescription>
          </Checkbox>
        </AllowDataUsageContainer>
      )}

      <FormButtonContainer>
        <Button
          onClick={handleSavePlan}
          width={"292px"}
          margin={"0 0 15px 0"}
          variant={"default"}
          theme={themeDefault}
          label={
            planOverview?.PlanOverViewData?.totalCashPayble !== "0.00"
              ? "Proceed to payment"
              : "Submit Application"
          }
          disabled={!isPaymentAllowed}
        ></Button>
      </FormButtonContainer>

      <Modal show={editModalVisible} onClose={() => setEditModalVisible(false)}>
        <EditModal data={editModalData}></EditModal>
      </Modal>

      <Modal show={errorModalVisible}>
        <ErrorModal data={errorModalData}></ErrorModal>
      </Modal>
      </Aligner>
    </MainContainer>
  );
};

export default Review;

//Added padding for this because the max-width is 792, so stepper will overlap
const Container = styled.div`
  position: relative;
  margin: 0 auto;
  max-width: ${CONTAINER_SIZE.mobiles}px;
  display: flex;
  flex-wrap: wrap;

  @media (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    max-width: ${CONTAINER_SIZE.desktops}px;
  }
  @media (min-width: ${SCREEN_SIZE.mobileSteper}px) {
    margin-top: 64px;
  }
`;

const AccordianContainer = styled.div`
  background-color: #fff !important;
  /* max-width: ${CONTAINER_SIZE.mobiles}px; */
  width: 100%;
  & div {
    border-radius: 16px;
    background-color: #fff !important;
    box-shadow: none;
  }

  @media (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    max-width: ${CONTAINER_SIZE.desktops}px;
    border-radius: 16px;
  }
`;

const EditBtnParagraph = styled.p`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
  color: #883e89;
`;

const HeaderTitleCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 28px;
  line-height: 140%;
  color: #434343;
  @media screen and (max-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-size: 20px;
  }
`;

const MessageBoxParagraphCss = css`
  font-family: "Open Sans";
  font-style: normal;
  line-height: 180%;
  color: #444444;
  font-size: 14px;
  font-weight: 400;
`;

const Aligner = styled.div`
  position: absolute;
  left: 0;
  margin-top: 54px;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    position: unset;
  }
`;
const FormContainer = styled.div<FormContainerProps>`
  flex-direction: column;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  /* max-width: 327px; */
  /* width: 100%; */
  transition: all 0.2s ease;
`;

const FormHeaderContainer = styled.div`
  display: block;
  /* margin-top: 24px; */
  margin-bottom: 24px;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    margin-bottom: 48px;
  }
`;

const FormContentContainer = styled.div`
  margin-bottom: 16px;
`;

const FormHeaderTitleContainer = styled.div`
  display: block;
  margin: 0 auto;
  margin-bottom: 16px;
  @media screen and (max-width: ${SCREEN_SIZE.mobilesUp}px) {
    padding: 0 20px;
    margin: 0 20px 16px 20px;
  }
`;

const FormHeaderDescriptionContainer = styled.div`
  display: block;
  margin: 0 50px;
  @media screen and (max-width: ${SCREEN_SIZE.mobilesUp}px) {
    margin: 0;
    padding: 0;
  }
`;

const FormButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 80px;
  margin-bottom: 100px;
  column-gap: 40px;
  width: 100%;
  padding: 0;
  @media screen and (max-width: ${SCREEN_SIZE.mobilesUp}px) {
    column-gap: 0;
    row-gap: 10px;
    margin-top: 40px;
    flex-direction: column;
    align-items: center;
  }
`;

const HeaderDescriptionCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  padding: unset;
  text-align: center;
  color: #8a8988;
  @media screen and (max-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-weight: 400;
    padding: 0 24px;
  }
`;

const AllowDataUsageContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  column-gap: 16px;
  padding: 0 24px;
  margin-top: 50px;
`;

const DataUsageDescription = styled.p<{ theme: ITheme }>`
  color: ${(props) => props.theme.colors.grey[1400]};
  font-size: 16px;
  font-weight: 400;
  line-height: 1.4;
`;

const container_with_bg_css = css`
  margin: 24px 0 0 0;
  &:nth-child(1) {
    margin: 24px 0 0 0;
  }
`;

const title_with_bg_css = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  @media screen and (max-width: ${SCREEN_SIZE.mobilesUp}px) {
    width: unset;
    font-size: 18px;
  }
`;

export interface FormContainerProps {
  margin?: string;
  maxWidth?: string;
}

export interface MessageNoteProps {
  color?: string;
}

export interface StepInterface {
  label: string;
  isCurrentStep: boolean;
}

const args = {
  theme: themeDefault,
  className: container_with_bg_css,
  title: "Personal Information",
  titleClassName: title_with_bg_css,
  titleColor: "#000",
  titleFontSize: 18,
  showHeaderBackground: true,
  headerBackgroundColor: "#FAFAFA",
  contentMarginLeft: "0",
  contentMarginRight: "0",
  showBottomLine: false,
  bottomLineColor: "#000",
  showExtraElement: true,
};
